import * as React from "react";
import { forwardRef } from "react";
const SvgChevronRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.7049 10L12.2949 11.41L16.8749 16L12.2949 20.59L13.7049 22L19.7049 16L13.7049 10Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgChevronRight);
export { ForwardRef as ReactComponent };
